<div class="row h-100 w-100 m-0">

	<div class="image-width p-0 " style="z-index: 3;">
		<div class="image-side"></div>
	</div>
	<div class="header-width header-zone">
		<form [formGroup]="summarizePage" id="summarize-page" (ngSubmit)="onSubmit(summarizePage)">
			<app-header></app-header>
			<main class="summery-wrapper-form">
				<div class="title">
					<h1 *ngIf="!isAdvisor">{{'SUMMARIZE.MSG_1'|translate:{name:user.firstName} }}</h1>
					<h1 *ngIf="isAdvisor">
						{{'SUMMARIZE.MSG_1-advisor'|translate:{name:user.firstName,nameClient:user.nameClient} }}</h1>
				</div>
				<div class="sub-title">{{'SUMMARIZE.MSG_2'|translate}}</div>
				<div class="categories">
					<div class="sub-category">
						<div><img src="assets/app-images/component-summary-page-txt-icon-copy@3x.png" alt=""></div>
						<div>
							<div class="summary">{{'SUMMARIZE.LABEL_1'|translate}}</div>
							<div class="ammount">{{user.propertyValue.toLocaleString()}}</div>
						</div>
					</div>
					<div class="sub-category">
						<div><img src="assets/app-images/component-summary-page-txt-icon-copy-4@3x.png" alt=""></div>
						<div>
							<div class="summary">{{'SUMMARIZE.LABEL_2'|translate}}</div>
							<div class="ammount">{{user.mortgageAmount.toLocaleString()}}</div>
						</div>
					</div>
					<div class="sub-category">
						<div><img src="assets/app-images/component-summary-page-txt-icon-copy-5@3x.png" alt=""></div>
						<div>
							<div class="summary">{{'SUMMARIZE.LABEL_3'|translate}}</div>
							<div class="ammount">{{user.monthlyRefundAmount.toLocaleString()}}</div>
						</div>
					</div>
				</div>

				<div *ngIf="isAdvisor" class="row mt-4 py-2 justify-content-center">
					<div class="col-5 mt-2">
						<h3>רוצה לשייך את התיק לתהליך משכנתא מרחוק?</h3>
					</div>
					<div class="col-3 form-group">
						<div class="d-flex">
							<label class="h4 m-2"><input type="radio" formControlName="remoteFlow" [value]="'YES'"> כן</label>
							<label class="h4 m-2"><input type="radio" formControlName="remoteFlow" [value]="'NO'"> לא</label>
						</div>
						<div class="form-text m-error" *ngIf="submitted && summarizePage.get('remoteFlow')?.value === ''">אנא בחר אחת מהאפשרויות</div>
					</div>
				</div>
				<div class="row py-1 justify-content-center">

	
				</div>

				<div *ngIf="isAdvisor && summarizePage.get('remoteFlow')?.value === 'NO'" class="row py-1 justify-content-center">
						<div class="col-5">
							<h3>{{'SUMMARIZE.BRANCH-QUESTION'|translate}}</h3>
						</div>
						<div class="col-3 form-group">
							<app-mat-autocomplete [data]="branchList" formControlName="continueBranch"
												  placeholder="{{'SUMMARIZE.BRANCH-PH'|translate}}"></app-mat-autocomplete>
							<app-messages *ngIf="isDisplayed3" [msgArr]="errorMessageOnComponent3"></app-messages>
						</div>
					</div>

					<div class="sub-title">{{'SUMMARIZE.MSG_5'|translate}}</div>
					<div class="mb-5">
						<textarea placeholder="{{'SUMMARIZE.PLACE_HOLDER' | translate}}" formControlName="textArea"
								  attr.aria-label="{{'SUMMARIZE.PLACE_HOLDER' | translate}}" #summarizeTextArea
								  data-id="summary-textarea"></textarea>
					</div>
					<div class="col-12 mr-2">
						<h3>{{'SUMMARIZE.QUESTION'|translate}}</h3>
					</div>
					<div class="col-12 mt-2 mr-2">
						<div class="section py-5">
							<input type="radio" class="app-input" formControlName="emailOrApp" id="emailRadio" checked
								   [value]="'02'">
							<label for="emailRadio" tabindex="0"
								   data-id="emailRadioLabel">{{'SUMMARIZE.AGREE_EMAIL'|translate}}</label>

							<input type="radio" class="app-input" formControlName="emailOrApp" id="appRadio" [value]="'01'">
							<label class="mr-5" for="appRadio" tabindex="0"
								   data-id="appRadioLabel">{{'SUMMARIZE.AGREE_APP'|translate}}</label>

							<input type="radio" class="app-input" formControlName="emailOrApp" id="advisorRadio"
								   [value]="'05'">
							<label class="mr-5" for="advisorRadio" tabindex="0"
								   data-id="advisorRadioLabel">{{'SUMMARIZE.ADVISOR_APP'|translate}}</label>
						</div>
					</div>
					<app-messages *ngIf="isDisplayed2" [msgArr]="errorMessageOnComponent2"></app-messages>

					<app-loader-page [isloading]="isloading"></app-loader-page>
					<app-messages *ngIf="errorMessage" [msgArr]="errorMessage"></app-messages>

					<div class="d-flex justify-content-center justify-content-md-start mt-3">
						<div class="mb-5">
							<button type="submit" *ngIf="isloading === false" class="button app-button  button-primary"
									data-id="but-summary-submit">
								{{'SUMMARIZE.BTN_SEND_LABEL'|translate}}
							</button>
						</div>
					</div>
					<!-- <div *ngIf="isloading">
		<div class="loader"></div>
	</div> -->
</main>
		</form>
	</div>
</div>


// WEBPACK FOOTER //
// ./src/app/summarize-page/summarize-page.component.html